import MainComponentWrapper from "../Common/MainComponentWrapper";
import useHttpHook from "../../Hooks/HttpHook";
import { useEffect, useState } from "react";
import {
  DeletePromoCodeApi,
  GetAllOrganizerEventsApi,
  GetPromocodeList,
  GetUsersApi,
} from "../../utils/ApiConstant";
import {
  createObjectForPaginatedResult,
  dateFormatter,
} from "../../utils/Helper";
import EditPromocodeModel from "./EditPromocodeModel";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { PromocodeLanguage } from "../../utils/Languages";
import AddPromocodeModel from "./AddPromocodeModel";
import MainPagination from "../Common/MainPagination";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const PromocodeList = ({ addPromocodeModel, closeAddModel }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [promocodeList, setPromocodeList] = useState();
  const [editPromocodeModel, setEditPromoCodeModel] = useState(false);
  const [selectedPromocode, setSelectedPromocode] = useState({});
  const [deleteModel, setDeleteModel] = useState(false);
  const [events, setEvents] = useState([]);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    getPromocodes();
    getOrganizerEvents();
    getUsers();
  }, []);
  //   console.log({ promocodeList });

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const changeEditModalState = (promocode) => {
    setSelectedPromocode(promocode);
    setEditPromoCodeModel(!editPromocodeModel);
  };

  const getUsers = async () => {
    const res = await sendRequest(GetUsersApi, {
      method: "get",
    });
    if (res?.status === 1) {
      setUsers(res.data);
    }
  };

  const getPromocodes = async (page = 1) => {
    const promocodes = await sendRequest(GetPromocodeList + "?page=" + page, {
      method: "get",
    });
    if (promocodes?.status !== 1) {
      if (page === 1) {
        setPromocodeList({ status: 0, data: { itemsList: [] } });
      }
      return;
    }
    if (page === 1) {
      setPromocodeList(promocodes);
    } else {
      setPromocodeList((prevState) => {
        return createObjectForPaginatedResult(promocodes, prevState);
      });
    }
  };

  const deletePromocode = async (promocode) => {
    try {
      // console.log({ promocode });
      await sendRequest(`${DeletePromoCodeApi}/${promocode}`, {
        method: "delete",
      });
      await getPromocodes();
      setDeleteModel(false);
    } catch (error) {
      console.log(error);
    }
  };

  const confirmDelete = (promocode) => {
    setSelectedPromocode(promocode);
    setDeleteModel(!deleteModel);
  };

  const getOrganizerEvents = async () => {
    try {
      const res = await sendRequest(GetAllOrganizerEventsApi, {
        method: "GET",
      });

      if (res?.status === 1) {
        setEvents(res.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-promo-code-body">
        <div className="event-promo-code-table-wrap">
          {promocodeList && promocodeList.data?.itemsList?.length > 0 ? (
            <MainPagination
              getEventsMethod={getPromocodes}
              MainData={promocodeList}
              PaginationType="paginate"
            >
              <div className="event-promo-code-table-card">
                <table className="event-promo-code-table" aria-label="Promo codes">
                  <thead>
                    <tr>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.promocode}
                      </th>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.type}
                      </th>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.discount}
                      </th>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.minPurchase}
                      </th>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.expiryDate}
                      </th>
                      <th scope="col">
                        {PromocodeLanguage.ListPromocodeTable.Columns.action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {promocodeList.data.itemsList.map((promocode, index) => (
                      <tr
                        key={promocode._id || promocode.promocode || index}
                        className="event-promo-code-row"
                      >
                        <td className="event-promo-code-cell-code">
                          {promocode.promocode}
                        </td>
                        <td>{promocode.type}</td>
                        <td>{promocode.discount}</td>
                        <td>{promocode.minPurchase}</td>
                        <td>{dateFormatter(promocode.expiryDate)}</td>
                        <td className="event-promo-code-cell-actions">
                          <div className="event-promo-code-actions">
                            <button
                              type="button"
                              className="event-promo-code-action is-edit"
                              aria-label={`Edit ${promocode.promocode}`}
                              onClick={() => changeEditModalState(promocode)}
                            >
                              <i className="bi bi-pencil" aria-hidden="true"></i>
                            </button>
                            <button
                              type="button"
                              className="event-promo-code-action is-delete"
                              aria-label={`Delete ${promocode.promocode}`}
                              onClick={() => confirmDelete(promocode.promocode)}
                            >
                              <i className="bi bi-trash" aria-hidden="true"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </MainPagination>
          ) : (
            <div className="event-promo-code-table-card event-promo-code-table-card--empty">
              <div className="event-promo-code-empty">
                {PromocodeLanguage.ListPromocodeTable.NoPromocode}
              </div>
            </div>
          )}
        </div>
      </div>
      {editPromocodeModel && (
        <EditPromocodeModel
          closeEditModel={changeEditModalState}
          promocode={selectedPromocode}
          refetch={getPromocodes}
          eventList={events}
          users={users}
        />
      )}
      {deleteModel && (
        <ModalWrapper
          title={PromocodeLanguage.DeletePromocodeModel.title}
          CloseModalHandler={() => setDeleteModel(false)}
          submitText={PromocodeLanguage.DeletePromocodeModel.submitText}
          clickHandler={() => deletePromocode(selectedPromocode)}
          dialogClassName="event-promo-delete-modal-dialog"
          contentClassName="event-promo-delete-modal"
          headerClassName="event-promo-delete-modal-header"
          bodyClassName="event-promo-delete-modal-body"
          footerClassName="event-promo-delete-modal-footer"
          closeClass="event-promo-code-modal-btn-close"
          submitClass="event-promo-code-modal-btn-save"
        >
          <p>{PromocodeLanguage.DeletePromocodeModel.message}</p>
        </ModalWrapper>
      )}
      {addPromocodeModel && (
        <AddPromocodeModel
          events={events}
          getPromocodes={getPromocodes}
          closeAddModel={closeAddModel}
          users={users}
        />
      )}
    </MainComponentWrapper>
  );
};

export default PromocodeList;
